import React, { Component } from 'react';
import ReactHighcharts from 'react-highcharts';
import FullenChart from 'highcharts/modules/funnel';
import TileChart from 'highcharts/modules/tilemap';
import HeatMap from 'highcharts/modules/heatmap';
import ChartHOC from './ChartHOC'

class Charts extends Component {
    constructor(props) {
        super(props);
        FullenChart(ReactHighcharts.Highcharts)
        TileChart(ReactHighcharts.Highcharts)
        HeatMap(ReactHighcharts.Highcharts)
    }
    componentWillMount() {
        // console.log(this.props)
    }
    render () {
        return (
            <ReactHighcharts config={this.props.config} ref="chart"></ReactHighcharts>
        )
    }
}
export default ChartHOC(Charts);